import { jsx as _jsx } from "react/jsx-runtime";
import { toClassName } from '../../utils/ClassNameUtils.js';
import { toFlexContainerClassName, toFlexItemClassName, } from '../../utils/FlexboxUtils.js';
import { toSpacingClassName, } from '../../utils/LayoutPropsUtils.js';
export const HoverRevealContainer = ({ children, ...props }) => {
    return (_jsx("div", { className: toClassName('hover-reveal-container', toFlexContainerClassName(props), toSpacingClassName(props)), children: children }));
};
HoverRevealContainer.Item = ({ forceVisible, style, children, ...props }) => {
    return (_jsx("div", { className: toClassName('item', forceVisible && 'is-visible', toFlexItemClassName(props), toSpacingClassName(props)), style: style, children: children }));
};
HoverRevealContainer.Item.displayName = 'HoverRevealContainer.Item';
//# sourceMappingURL=HoverRevealContainer.js.map